import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0582f73b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto w-full" }
const _hoisted_2 = { class: "row overflow-hidden" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  class: "flex justify-between items-center cursor-pointer select-none tab-label bg-white rounded-lg",
  for: "chck3"
}
const _hoisted_6 = { class: "elements grid grid-cols-5 w-full pt-1 pb-1 text-left self-center bg-primary-50" }
const _hoisted_7 = { class: "font-bold my-auto truncate" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "my-auto truncate" }
const _hoisted_10 = {
  key: 0,
  class: "clocking-in-date"
}
const _hoisted_11 = { class: "my-auto" }
const _hoisted_12 = {
  key: 0,
  class: "clocking-in-date"
}
const _hoisted_13 = { class: "actions flex col-span-2" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown-section flex test p-1 ml-auto bg-white my-auto"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold" }, "Vedi dettagli", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  "data-reactid": "266",
  fill: "none",
  height: "24",
  stroke: "#606F7B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewbox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
], -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "no-details flex test p-1 ml-auto my-auto"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold user-tab-element delete-button" }, "Elimina", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "tab-content pb-2"
}
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "text-left user pt-2 flex" }
const _hoisted_24 = { class: "name flex-grow font-bold" }
const _hoisted_25 = { class: "buttons" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "font-bold user-tab-element suspend mr-3" }
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteToolItem = _resolveComponent("DeleteToolItem")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              class: "primary w-full absolute z-10 cursor-pointer opacity-0 h-16 left-0 top-1 bg-white",
              id: "chck3",
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapsed) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isCollapsed]
            ]),
            _createElementVNode("header", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", _hoisted_7, [
                  (_ctx.modelValue.primaryField)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.modelValue.primaryField), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h3", _hoisted_9, [
                  (_ctx.modelValue.secondaryField)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.modelValue.secondaryField), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h3", _hoisted_11, [
                  (_ctx.modelValue.createdTs)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("DD/MM/YYYY")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.modelValue.userAssignmentIds && _ctx.modelValue.userAssignmentIds.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                  _createElementVNode("button", {
                    class: "delete-tool-item z-10",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.isShowingToolItemDeleteDialog = true), ["stop"]))
                  }, _hoisted_20)
                ])
              ])
            ]),
            (_ctx.modelValue.userAssignments && _ctx.modelValue.userAssignmentIds && _ctx.modelValue.userAssignmentIds.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.userAssignments, (userAssignment) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(userAssignment.userName) + " " + _toDisplayString(userAssignment.userSurname), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "ml-auto",
                            onClick: ($event: any) => (_ctx.toggleAssignmentSuspension(userAssignment))
                          }, [
                            _createElementVNode("h3", _hoisted_27, _toDisplayString(userAssignment.isEnabled ? 'Sospendi' : 'Annulla sospensione'), 1)
                          ], 8, _hoisted_26),
                          _createElementVNode("button", null, [
                            _createElementVNode("h3", {
                              class: "font-bold user-tab-element delete-button",
                              onClick: ($event: any) => (_ctx.onDeleteUserAssignment(userAssignment))
                            }, "Elimina", 8, _hoisted_28)
                          ])
                        ])
                      ]))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.isShowingToolItemDeleteDialog)
        ? (_openBlock(), _createBlock(_component_DeleteToolItem, {
            key: 0,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowingToolItemDeleteDialog = false)),
            toolId: _ctx.modelValue.toolId,
            toolItemId: _ctx.modelValue.id
          }, null, 8, ["toolId", "toolItemId"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Aggiornamento..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}